import "@/bootstrap"
import moment from "moment";
import Mask from "vue-the-mask"
import {createApp, h} from "vue";
import { createInertiaApp } from '@inertiajs/vue3'
import Notifications from "@kyvg/vue3-notification"
import LayoutDefault from "@/Layouts/Default";
import store from "@/Vuex/Store";

createInertiaApp({
    resolve: name => {
        const page = require(`./Pages/${name}`).default
        page.layout = page.layout || LayoutDefault
        return page
    },
    setup({el, App, props, plugin}) {
        const app = createApp({render: () => h(App, props)});
        app.config.globalProperties.$moment = moment;
        app.use(plugin)
        app.use(Notifications)
        app.use(Mask)
        app.use(store)
        app.mount(el)
    },
});
